import { render, staticRenderFns } from "./QuadientImpress.vue?vue&type=template&id=3480051d&scoped=true&"
import script from "./QuadientImpress.vue?vue&type=script&lang=js&"
export * from "./QuadientImpress.vue?vue&type=script&lang=js&"
import style0 from "./QuadientImpress.vue?vue&type=style&index=0&id=3480051d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480051d",
  null
  
)

export default component.exports